import React, { useState } from "react";
import cs from "classnames";
import './RangeSlider.scss';

type TRangeSlider = {
  minValue?: number;
  maxValue?: number;
  onChange?: (val: number) => void;
  name?: string;
  interval?: number;
  value?: number;
};

export const RangeSlider = ({
  minValue = 100,
  maxValue = 150000,
  interval = 1,
  value,
  onChange,
  name,
}: TRangeSlider) => {
  var minp = 0;
  var maxp = 100;
  const minv = Math.log(minValue > 0 ? minValue : 100);

  const maxv = Math.log(maxValue);

  const scale = (maxv - minv) / (maxp - minp);
  const getVal = (position) => {
    return Math.exp((position - minp) * scale + minv);
  };
  const getPos = (value) => {
    return minp + (Math.log(value) - minv) / scale;
  };
  const [position, setPosition] = useState(getPos(value));

  const calculateValue = (position) => {
    if (position === 0) return 0;
    const value = getVal(position);

    if (value > 1000) {
      return Math.round(value / 100) * 100;
    }
    if (value > 100) {
      return Math.round(value / 10) * 10;
    }
    return Math.round(value);
  };

  return (
    <div className={"c-hex-range-slider-container "}>
      <input
        type={"range"}
        className={"c-hex-range-slider-input"}
        name={name}
        value={position}
        min={0}
        max={100}
        onChange={(e) => {
          const newPosition = e.target.value;
          setPosition(Number(newPosition));

          onChange(calculateValue(newPosition));
          const newValues = {
            position: newPosition,
            value: calculateValue(newPosition),
          };

          //   @TODO: handle onChange
        }}
      />
      <div
        className={"c-hex-range-slider-bar"}
        style={{ width: `${position}%` }}
      />
      <div
        className={cs("c-hex-range-slider-thumb", {
          "c-hex-range-slider-thumb-active": value > 0,
        })}
        style={{ left: `calc(${position}% - 16px)` }}
      />
    </div>
  );
};
